module.exports = __webpack_public_path__ + "../resources/images/connectionError-6015da4d02acd0e145c7de0f13bc5471.svg";